"use client";

import React from 'react';
import { PinterestIcon } from './Icons';

interface PinterestSaveButtonProps {
    url: string;
    media: string;
    description: string;
    className?: string;
}

export const PinterestSaveButton: React.FC<PinterestSaveButtonProps> = ({ url, media, description, className = "" }) => {
    const handlePin = (e: React.MouseEvent) => {
        e.preventDefault();
        const pinUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(media)}&description=${encodeURIComponent(description)}`;
        window.open(pinUrl, '_blank', 'width=600,height=600');
    };

    return (
        <button
            onClick={handlePin}
            className={`flex items-center gap-2 px-6 py-4 bg-[#E60023] hover:bg-[#AD0018] text-white rounded-xl font-bold transition-all shadow-md active:scale-95 ${className}`}
            title="Save to Pinterest"
        >
            <PinterestIcon className="w-5 h-5 text-white" />
            <span>Save</span>
        </button>
    );
};
